import { Tutorial } from '@components/tutorial/Tutorial';
import { useGameStore, useAppStore } from '@stores';
import { useTranslation } from 'react-i18next';
import * as Shared from '@shared/lib';
import { Step } from 'react-joyride';

export function NavTutorial() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Tutorial.Nav' });
  const { gameEndedState } = useGameStore();
  const { userData, tab } = useAppStore();

  if (gameEndedState) return null;
  if (tab !== 'navigation') return null;

  const fishingLevel = Shared.planetData.find(p => p.type === 'fishing')?.levelRange.from;
  const miningLevel = Shared.planetData.find(p => p.type === 'mining')?.levelRange.from;
  if (!fishingLevel || !miningLevel) return null;

  if (!userData.tutorials.includes('Nav')) {
    const steps: Step[] = [
      {
        target: '.planet-Strava',
        placement: 'center',
        content: t('nav0'),
      },
      {
        target: '.planet-Strava',
        content: t('nav1'),
      },
      {
        target: '.planet-Strava',
        content: <p className="text-primary">{t('nav6')}</p>,
      },
    ];

    return <Tutorial tutorialKey="Nav" steps={steps} />;
  }

  if (!userData.tutorials.includes('Upgrade') && userData.tutorials.includes('Combat')) {
    const steps: Step[] = [
      {
        target: '.planet-Strava',
        placement: 'center',
        content: t('navMod0'),
      },
      {
        target: '.nav-arsenal',
        content: <p className="text-primary">{t('navMod1')}</p>,
      },
    ];

    return <Tutorial tutorialKey="Upgrade" steps={steps} noSave />;
  }

  if (
    userData.tutorials.includes('Upgrade')
    && userData.missionLevel < 10
    && !userData.tutorials.includes('Combat2')
    && !userData.tutorials.includes('Inv')
  ) {
    const steps: Step[] = [
      {
        target: '.planet-Strava',
        placement: 'center',
        content: t('navUp0'),
      },
      {
        target: '.planet-Strava',
        content: <p className="text-primary">{t('navUp1')}</p>,
      },
    ];

    return <Tutorial tutorialKey="Combat2" steps={steps} />;
  }

  if (
    userData.tutorials.includes('Upgrade')
    && userData.missionLevel >= 10
    && !userData.tutorials.includes('Combat3')
    && !userData.tutorials.includes('Inv')
  ) {
    const steps: Step[] = [
      {
        target: '.planet-Strava',
        placement: 'center',
        content: t('navUp2'),
      },
      {
        target: '.nav-arsenal',
        content: <p className="text-primary">{t('navUp3')}</p>,
      },
    ];

    return <Tutorial tutorialKey="Combat3" steps={steps} />;
  }

  if (userData.missionLevel >= fishingLevel) {
    return <Tutorial steps={[{ target: '.planet-Avalon', content: t('nav3') }]} tutorialKey="NavFishing" />;
  }

  if (userData.missionLevel >= miningLevel) {
    return <Tutorial steps={[{ target: '.planet-Taloris', content: t('nav2') }]} tutorialKey="NavMining" />;
  }
}